import React, { useEffect, useState } from 'react'
import { Form, Input, Button } from 'antd'
import { makeStyles } from '@material-ui/core'
import { PhoneOutlined, LockOutlined } from '@ant-design/icons'
import { trackPromise, usePromiseTracker } from 'react-promise-tracker'
import { useRouter } from '../../routes'
import { useData } from '../../data'

const useStyles = makeStyles(theme => ({
    root: {
        height: '100%',
        width: '100%'
    },
    content: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        textAlign: 'center',
        minWidth: '20%'
    },
    error: {
        fontWeight: 'bold',
        fontSize: 16,
        color: 'red'
    },
    login: {
        textAlign: 'center'
    },
    logo: {
        display: 'flex',
        margin: theme.spacing(3, 0),
        justifyContent: 'center',
        alignItems: 'center'
    },
    image: {
        width: '8rem',
        height: '8rem'
    },
    logoImage: {
        height: 100,
        marginBottom: theme.spacing(3)
    }
}))

/**
 * Login page component
 *
 * Provides user with email and password input field and connect
 * to server to authenticate the details.
 *
 * If authentication fails, it renders an error text
 */
function doesHttpOnlyCookieExist(cookiename) {
    var d = new Date();
    d.setTime(d.getTime() + (1000));
    var expires = "expires=" + d.toUTCString();

    document.cookie = cookiename + "=new_value;path=/;" + expires;
    console.log(document.cookie.indexOf(cookiename + '=') == -1);
    return document.cookie.indexOf(cookiename + '=') == -1;
}

const LoginPage = (props) => {
    const [error, setError] = useState(null)
    const [user, setUser] = useState(null)

    const classes = useStyles()
    const data = useData()
    const auth = data.auth()

    const router = useRouter()

    // load the current user
    const loadUser = () => {
        trackPromise(
            auth.getCurrentUser()
                .then(setUser)
                .catch(console.log), 'get_user'
        )
    }

    // get the currently signed in user
    useEffect(() => {
        loadUser()
        // eslint-disable-next-line
    }, [])

    // redirect to dashboard if logged in
    if(user) {
        router.push('/dashboard')
    }
    // login callback
    const login = ({ username, password }) => {
        setError(null)

        trackPromise(
            auth.signin(username, password)
                .then((user) => {
                    // route to dashboard
                    router.push(user)
                }).catch(error => {
                    console.log(error)

                    setError(error.message)
                })
        )
    }

    const { promiseInProgress } = usePromiseTracker()

    return (
        <div className={classes.root}>
            <div className={classes.content}>
                <img src="/apple-touch-icon.png" alt="logo" className={classes.logoImage} />
                <Form
                    layout="vertical"
                    onFinish={login}
                    name="login-form"
                >
                    <Form.Item name="username" rules={[{ required: true }]}>
                        <Input placeholder="Username" size="large" suffix={<PhoneOutlined />} />
                    </Form.Item>
                    <Form.Item name="password" rules={[{ required: true }]}>
                        <Input.Password placeholder="Password" size="large" suffix={<LockOutlined />} />
                    </Form.Item>

                    <Form.Item>
                        <Button type="primary" block size="large" loading={promiseInProgress} htmlType="submit" >Login</Button>
                    </Form.Item>

                    <Form.Item>
                        <p className={classes.error}>{error}</p>
                    </Form.Item>

                </Form>
            </div>
        </div>
    )
}

export default LoginPage
